import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'

dayjs.extend(isToday)

export const getDeliveryDate = (type: string, since?: string, until?: string, date?: string) => {
    let mainDate = until

    if (type === 'window') {
        mainDate = since
    } else if (date) {
        mainDate = date
    }

    let day

    if (dayjs(mainDate).isToday()) {
        day = ''
    } else if (dayjs(mainDate).add(1, 'day').isToday()) {
        day = 'včera'
    } else if (dayjs(mainDate).add(-1, 'day').isToday()) {
        day = 'zítra'
    } else if (dayjs(mainDate).add(-2, 'day').isToday()) {
        day = 'pozítří'
    } else {
        day = dayjs(mainDate).format('D.M')
    }

    day = day ? `${day}, ` : ''

    let deliveryTime = ''

    const mainTime = dayjs(mainDate).format('HH:mm')

    if (type === 'asap') {
        deliveryTime = `${day}do ${mainTime}`
    } else if (type === 'exact') {
        deliveryTime = `${day}v ${mainTime}`
    } else if (type === 'window') {
        const sinceTime = dayjs(since).format('HH:mm')
        const untilTime = dayjs(until).format('HH:mm')

        deliveryTime = `${day}${sinceTime} - ${untilTime}`
    }

    return deliveryTime
}
